import { motion, useInView, Variants } from "framer-motion";
import { useRef, ReactNode, Children, cloneElement, isValidElement } from "react";

interface StaggerContainerProps {
  children: ReactNode;
  staggerDelay?: number;
  duration?: number;
  className?: string;
  once?: boolean;
  amount?: number;
}

const childVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const StaggerContainer = ({
  children,
  staggerDelay = 0.1,
  duration = 0.5,
  className = "",
  once = true,
  amount = 0.2,
}: StaggerContainerProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once, amount });

  const containerVariants: Variants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: staggerDelay,
      },
    },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={containerVariants}
      className={className}
    >
      {Children.map(children, (child) => {
        if (isValidElement(child)) {
          return (
            <motion.div
              variants={childVariants}
              transition={{ duration, ease: [0.25, 0.1, 0.25, 1] }}
              style={{ display: 'contents' }}
            >
              {child}
            </motion.div>
          );
        }
        return child;
      })}
    </motion.div>
  );
};

export default StaggerContainer;
